import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Box, Typography, Grid, Paper, MenuItem, Popover } from '@material-ui/core'
import { AppButton, DisplayMessage, Loader } from '../../Components'
import Summary from './Summary'
import { useStyles } from './style'
import UpcomingEvents from './UpcomingEvents'
import CompletedEvents from './CompletedEvents'
import SystemsOverview from './SystemsOverview'
import * as messageTypes from '../../utils/messageTypes'
import { accountService } from '../../Services/AccountService/AccountService'
import { KeyboardArrowDown } from '@material-ui/icons'
import { OutlinedButton } from  '../../elements'

function Dashboard(props) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [accounts, setAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState((props.isSuperAdmin || props.isViewOnly) ? '' : { id: props.currentUser.account_id })
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const { currentUser } = props

  const getAllAccounts = () => {
    setLoading(true)
    accountService.getAllAccounts(currentUser.account_id)
      .then(accountsData => {
        setAccounts(accountsData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? 'simple-popover' : undefined

  useEffect(() => {
    if (props.isSuperAdmin || props.isViewOnly) {
      getAllAccounts()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => { setOpen(false) }} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Welcome {currentUser.user_name}!</Typography>
        <Box className={classes.buttonWrapper} style={{width: props.isSuperAdmin ? "430px" : ""}}>
          {(props.isSuperAdmin || props.isViewOnly) &&
            <Box>
              <AppButton aria-describedby={id} className={classes.popoverButton} text={
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box className={classes.paperText}>{selectedAccount ? `ACCOUNT | ${selectedAccount.company_name}` : 'SELECT ACCOUNT'}</Box>
                  <KeyboardArrowDown />
                </Box>
              } onClick={handleClick} />
              <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                classes={{ paper: classes.paper }}
              >
                {accounts.map(account => (
                  <MenuItem key={account.id} value={account.id} onClick={() => { setSelectedAccount(account); handleClose() }}>
                    <Box display="flex" justifyContent="space-between" width="100%">
                      <Box component="span">
                        {account.company_name}
                      </Box>
                    </Box>
                  </MenuItem>
                ))}
              </Popover>
            </Box>
          }
          {!props.isViewOnly && props.isSuperAdmin && <OutlinedButton label='FORECAST GRAPHS' height='47px' onClick={() => props.history.push('/dashboard/forecast-graphs')} />}
        </Box>
      </Box>
      {
        selectedAccount ?
          <>
            <Box mx={5}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Paper elevation={2} square>
                    <Summary account={selectedAccount.id} />
                  </Paper>
                </Grid>
              </Grid>
            </Box>
            {/* <Box mx={5}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper elevation={2} square>
              <SystemsOverview dots={dots} />
            </Paper>
          </Grid>
        </Grid>
      </Box> */}
            <Box mx={5}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Paper elevation={2} square>
                    <UpcomingEvents account={selectedAccount.id} />
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper elevation={2} square>
                    <CompletedEvents account={selectedAccount.id} />
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </> :
          <Paper elevation={2} className={classes.cardsWrapper}>
            <Box className={classes.selectMessageWrapper}>
              Please select an account
            </Box>
          </Paper>
      }
    </Box >
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isViewOnly, isAdmin } = auth
  return { currentUser, isSuperAdmin, isViewOnly, isAdmin }
}

export default connect(mapStateToProps, {})(Dashboard)